import type { FC } from 'react';
import React from 'react';

import styled from '@emotion/styled';

import { COLORS } from '@clutter/clean';

const PageNextChevron: FC<{
  fill?: string;
}> = ({ fill = COLORS.cloud }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="15"
    viewBox="0 0 9 15"
    fill="none"
  >
    <path
      d="M1.67988 14.4L8.87988 7.2L1.67988 0L-0.000117302 1.68L5.51988 7.2L-0.000117302 12.72L1.67988 14.4Z"
      fill={fill}
    />
  </svg>
);

const PagePrevChevron: FC<{
  fill?: string;
}> = ({ fill = COLORS.hippo }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="15"
    viewBox="0 0 9 15"
    fill="none"
  >
    <path
      d="M7.2 14.4L0 7.2L7.2 0L8.88 1.68L3.36 7.2L8.88 12.72L7.2 14.4Z"
      fill={fill}
    />
  </svg>
);

const PageNavigationButtons = styled.div<{ $gap: number }>`
  display: flex;
  gap: ${({ $gap }) => $gap}px;
`;

const PageNavigationButton = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  color: ${COLORS.cloud};
  background: ${COLORS.tealJungle};

  &:disabled {
    color: ${COLORS.hippo};
    background: #e4e4e4;
    cursor: default;
  }
`;

export const PageNavigation: FC<{
  count: number;
  index: number;
  onNavigate(_: (current: number) => number): void;
  /** Default 24px; Direct Mailer / Figma uses 36px between arrows. */
  gapPx?: number;
}> = ({ count, index, onNavigate, gapPx = 24 }) => {
  const next = index < count - 1;
  const prev = index > 0;

  const onNext = () => {
    onNavigate((current) => {
      current++;
      return current >= count ? count - 1 : current;
    });
  };

  const onPrev = () => {
    onNavigate((current) => {
      current--;
      return current < 0 ? 0 : current;
    });
  };

  return (
    <PageNavigationButtons $gap={gapPx}>
      <PageNavigationButton aria-label="Prev" onClick={onPrev} disabled={!prev}>
        <PagePrevChevron fill={prev ? COLORS.cloud : COLORS.hippo} />
      </PageNavigationButton>
      <PageNavigationButton aria-label="Next" onClick={onNext} disabled={!next}>
        <PageNextChevron fill={next ? COLORS.cloud : COLORS.hippo} />
      </PageNavigationButton>
    </PageNavigationButtons>
  );
};
